export default "__VITE_ASSET__DOM_ABxa__"